const carousels = document.querySelectorAll(".carousel");
carousels.forEach((carousel) => {
  const flkty = new Flickity(carousel, {
    cellAlign: carousel.dataset.cellAlign || "left",
    prevNextButtons: carousel.dataset.arrows === "true",
    pageDots: carousel.dataset.dots === "true",
    wrapAround: carousel.dataset.wrapAround === "true",
    adaptiveHeight: carousel.dataset.adaptiveHeight === "true",
    autoPlay:
      carousel.dataset.autoplay === "true"
        ? parseInt(carousel.dataset.autoplaySpeed)
        : false,
    contain: true,
    percentPosition: false,
    dragThreshold: 10,
    selectedAttraction: 0.025,
    friction: 0.28,
  });

  // 添加ready类来触发淡入效果
  carousel.classList.add("is-ready");
});
// class SupSlider extends HTMLElement {
//     constructor() {
//       super();
//       this.init();
//     }
  
//     init() {
//       if (typeof Flickity === 'undefined') {
//         window.addEventListener('flickity:loaded', () => this.initSlideshow());
//         return;
//       }
//       this.initSlideshow();
//     }
  
//     initSlideshow() {
//       const config = {
//         cellAlign: 'left',
//         contain: true,
//         wrapAround: this.dataset.wrapAround !== 'false',
//         prevNextButtons: this.dataset.arrows !== 'false',
//         pageDots: this.dataset.dots !== 'false',
//         adaptiveHeight: this.dataset.adaptiveHeight !== 'false',
//         draggable: true,
//         autoPlay:
//         this.dataset.autoplay === "true"
//           ? parseInt(this.dataset.autoplaySpeed) || 5000
//           : false,
//         // groupCells: parseInt(this.dataset.slidesPerView) || 3
//       };
  
//       // if (this.dataset.mobileSlides || this.dataset.tabletSlides) {
//       //   config.responsive = [
//       //     {
//       //       breakpoint: 768,
//       //       settings: {
//       //         groupCells: parseInt(this.dataset.mobileSlides) || 2
//       //       }
//       //     },
//       //     {
//       //       breakpoint: 1024,
//       //       settings: {
//       //         groupCells: parseInt(this.dataset.tabletSlides) || 3
//       //       }
//       //     }
//       //   ];
//       // }
  
//       const flickityInstance = new Flickity(this, config);
      
//       // 检查是否需要隐藏导航点
//       this.checkDotsVisibility(flickityInstance);
      
//       // 在窗口调整大小时重新检查
//       window.addEventListener('resize', () => {
//         this.checkDotsVisibility(flickityInstance);
//       });
//     }
    
//     // 添加这个新方法来检查是否应该显示导航点
//     checkDotsVisibility(flickity) {
//       if (!flickity) return;
      
//       // 如果滑块不能滚动（slides少于或等于1个）则隐藏导航点
//       const dotsElement = this.querySelector('.flickity-page-dots');
//       if (dotsElement) {
//         // 检查是否需要滚动（如果只有一页，就不需要导航点）
//         if (flickity.slides.length <= 1) {
//           dotsElement.style.display = 'none';
//         } else {
//           dotsElement.style.display = '';
//         }
//       }
      
//       // 同样对于前进/后退按钮，如果需要也可以隐藏
//       const prevNextButtons = this.querySelectorAll('.flickity-button');
//       if (prevNextButtons.length) {
//         prevNextButtons.forEach(button => {
//           if (flickity.slides.length <= 1) {
//             button.style.display = 'none';
//           } else {
//             button.style.display = '';
//           }
//         });
//       }
//     }
//   }
  
//   // 注册自定义元素
//   customElements.define('sup-slider', SupSlider);